

import React, { useEffect, useState } from "react";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../../utils/UtilsFormule";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const ProductSellingProductStock = ({
  setOnGetStockProduct,
  idProduct,
  nameProduct,
  idWarehouse,
}) => {
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [virualStock, setVirualStock] = useState();
  const [realStock, setRealStock] = useState();
const [listStock,setListStock]=useState([]);
  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnGetStockProduct(false);
  };

  useEffect(() => {
    setListStock([]);
    WarehouseService.priceVenteProductWarehouse(
      getCurrentUserId(),
      idProduct,
      idWarehouse
    )
      .then((response) => {

        if (!response.data.error) {
          setOpenAlert(true);
          setListStock(response.data.success);
        }
      })
      .catch((e) => {
        console.log("error", e);
      });
  }, []);

  return (
    <>
      <div class="modal fade" id="edit-brand-vente">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Les prix d'achat</h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Produit : {nameProduct}</label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                     <div class="card-body p-0">
                                      <table class="table  projects">
                                        <thead>
                                          <tr className="text-center">
                                            <th style={{ width: "12%" }}>Prix de vente</th>
                                            <th style={{ width: "12%" }}>Date de mise à jour</th>
                                            <th style={{ width: "12%" }}>Devise</th>                  
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {listStock &&
                                            listStock.map((element, i) => (
                                              <tr className="text-center" key={element.id}>
                                                <td>{element.initialSellingPrice} </td>
                                                <td>{UtilsFormule.formatDateHours(element.creationDate)}</td>
                                                <td>{element.devise}</td>
                                              </tr>
                                            ))}
                                        </tbody>
                                      </table>
                                    </div>
                </div>
              </div>
        
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductSellingProductStock;
